import PropTypes from "prop-types";
import React, { useState, useEffect, useContext } from "react";
import { Accordion, Card } from "react-bootstrap";
import {
  renderTableMergersAndAcquisitions,
  getCollapsedStatus,
  toggleAccordion,
  useSortableData,
  NameAndBadge,
  toggleAccordionOpen,
  getSetToggled,
} from "../dashboard-util/dashboard-utils";
import DashboardTableHeader from './DashboardTableHeader';
import DealsButtonRow from "./DealsButtonRow";
import TableHeaderColumn from "./TableHeaderColumn";
import CustomModal from "./CustomModal";
import "../dashboard-healthcare/dashboard-healthcare.scss";
import "../dashboard-mergers-and-acquisitions/dashboard-mergers-and-acquisitions.scss";
import { LoginContext } from "../../../services/api/authentication-api";
import { FluentAvatar } from "../../../components/FluentUI/Fluent-Avatar";

const DashboardMergersAndAcquisitions =  ({ type, users, setUsers }) => {
  const [members, setMembers] = useState([]);
  const [toggled, setToggled] = useState([]);
  const [show, setShow] = useState(false);
  const [showDeals, setShowDeals] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [accordionId, setAccordionId] = useState(`mergers-and-acquisitions-${type}-accordion`);
  const [collapsed, setCollapsed] = useState(true);
  const currentUser = useContext(LoginContext);
  const [juniorBankerView, setJuniorBankerView] = useState(false);
  
  useEffect(() => {
    if (users) {
      setMembers(users);
    }
  }, [users, type]);

 useEffect(() => {
    if (members) {
      setToggled(getSetToggled(members));
      mergersJuniorBankerView();
    }
  }, [members]);

  const showModal = (m, type) => {
    setSelectedMember(m);
    if (type === 'deals') setShowDeals(true);
    else setShow(true);
  };

  const mergersJuniorBankerView = () => {
    if(members?.length === 1 && members[0]?.UserId === currentUser.userID){
      setJuniorBankerView(true);
      toggleAccordionOpen(accordionId + "-" + members[0]?.UserId);
    }
  }

  const { items, requestSort, getArrowDirectionFor } = useSortableData(members);

  if (members?.length > 0) {
    return (
      <div className="new-dashboard table-wrapper">
        <div className="DashboardTableWrapper">
          <table>
            <thead>
              <tr className="DashboardTableHeader">
                <DashboardTableHeader
                  type={type}
                  accordionId={accordionId}
                  collapsed={collapsed}
                  setCollapsed={setCollapsed}
                  toggled={toggled}
                  setToggled={setToggled}
                  juniorBankerView={juniorBankerView}
                  DealsTaskId = {members?.[0]?.DealsTaskId}
                  setUsers={setUsers}
                />
              </tr>
            </thead>
            <div className="scrollable-dashboard">
              <Accordion>
                <Card className="MemberTableBodyWrapper sticky-header-dashboard">
                  <thead className="MemberTableColumnHeader">
                    <tr className="MemberTableColumnTitles">
                      <TableHeaderColumn
                        headerText={type.toUpperCase()}
                        sortKey="Name"
                        requestSort={requestSort}
                        getArrowDirectionFor={getArrowDirectionFor}
                        colClass="col-md-2"
                      />
                      <TableHeaderColumn
                        headerText="ACTIVE SELL-SIDE DEALS"
                        sortKey="ActiveSellSideDeals"
                        requestSort={requestSort}
                        getArrowDirectionFor={getArrowDirectionFor}
                        colClass="col-md-2"
                      />
                       <TableHeaderColumn
                        headerText="ACTIVE BUY-SIDE DEALS"
                        sortKey="ActiveBuySideDeals"
                        requestSort={requestSort}
                        getArrowDirectionFor={getArrowDirectionFor}
                        colClass="col-md-2"
                      />
                      <TableHeaderColumn
                        headerText="ACTIVE BAKE-OFFS/PITCHES"
                        sortKey="ActiveBakeOffsPitches"
                        requestSort={requestSort}
                        getArrowDirectionFor={getArrowDirectionFor}
                        colClass="col-md-2"
                      />
                      <TableHeaderColumn
                        headerText="WEEKEND HOURS"
                        sortKey="WeekendHours"
                        requestSort={requestSort}
                        getArrowDirectionFor={getArrowDirectionFor}
                        colClass="col-md-2"
                      />
                      <TableHeaderColumn
                        headerText="LAST UPDATE"
                        sortKey="LastUpdate"
                        requestSort={requestSort}
                        getArrowDirectionFor={getArrowDirectionFor}
                        colClass="col-md-1"
                      />
                      <th className="col-md-1"></th>
                    </tr>
                  </thead>
                </Card>
                <table>
                  <tbody className="healthcare-tablebody">
                    { items.length > 0 &&
                      items.map((member) => {
                        return (
                          <tr key={member?.UserId} className="healthcare-table-row">
                            <Card>
                              <div className="MemberTableBody mergersAndAcquisitionsRow row">
                                <td className="col-md-2 mt-2 dashboard-username">
                                  <FluentAvatar size={32} name={member?.Name} className="task-member-user"/>                                
                                  {
                                    juniorBankerView
                                    ?
                                      <NameAndBadge name={member.Name} />
                                    :
                                      <span className="Memberoverlaybutton mt-1 pl-1">
                                        {member.Name}
                                      </span>
                                  }
                                </td>
                                <td className="col-md-2 mt-2">
                                   {member.ActiveSellSideDeals}
                                </td>
                                <td className="col-md-2 mt-2">
                                   {member.ActiveBuySideDeals}
                                </td>
                                <td className="col-md-2 mt-2">
                                   {member.ActiveBakeOffsPitches}
                                </td>
                                <td className="col-md-2 mt-2">
                                  {member.WeekendHours}
                                </td>
                                <td className="col-md-1 mt-2 healthcare-last-updated">
                                  {member.LastUpdate}
                                </td>
                                <DealsButtonRow
                                  {...{
                                    member,
                                    toggled,
                                    showModal,
                                    toggleAccordion,
                                    accordionId,
                                    setToggled,
                                    setCollapsed,
                                    getCollapsedStatus,
                                    juniorBankerView
                                  }}
                                />
                              </div>
                              <Accordion.Collapse
                                eventKey={member.UserId}
                                scrollable={true}
                                className={accordionId}
                                //className={"scrollable-dashboard " + accordionId}
                                id={accordionId + "-" + member.UserId}
                              >                        
                                <Card.Body
                                  scrollable={true}
                                  className="scrollable-dashboard scrollable-power-deals"
                                >
                                  {renderTableMergersAndAcquisitions(member.TableDeals, true, true)}
                                </Card.Body>
                              </Accordion.Collapse>                              
                            </Card>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </Accordion>
            </div>
          </table>
          { selectedMember &&
            <CustomModal
              type={type}
              selectedMember={selectedMember}
              key={selectedMember.UserID}
              showState={showDeals}
              onHideFunction={() => setShowDeals(false)}
            />
          }
        </div>
      </div>
    );
  };
  return null;
};

DashboardMergersAndAcquisitions.propTypes = {
  type: PropTypes.string,
  users: PropTypes.arrayOf(PropTypes.object),
  setUsers: PropTypes.func.isRequired,
};

export default DashboardMergersAndAcquisitions;
